// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBJSSIXDfCpqLf1LtuxFuDJzeL_5A4YYag",
  authDomain: "digisofts-a0234.firebaseapp.com",
  projectId: "digisofts-a0234",
  storageBucket: "digisofts-a0234.appspot.com",
  messagingSenderId: "1034178390723",
  appId: "1:1034178390723:web:b638a1153f56bd4aec5076",
  measurementId: "G-8FWFYX2RHQ",
  databaseURL: "https://digisofts-a0234-default-rtdb.asia-southeast1.firebasedatabase.app/"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const analytics = getAnalytics(app); 